<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!transaction">
      <span class="loader"></span>
    </span>
    <div v-if="transaction" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <transaction-view-global
            :transaction="transaction"
            @onValidateTransaction="validateTransaction"
            @onCancelTransaction="cancelTransaction"
            @onDeleteTransaction="deleteTransaction"
            @onToggleOnHold="toggleOnHold"
            @onSendPaymentsToDpa="sendPaymentsToDpa"
          />
        </tab-pane>

        <!--<tab-pane title="label" id="2" v-if="transaction.signatures?.length">
          <span slot="title">
            <i class="fa fa-pencil"></i>
            {{ $t("SIGNATURES.SIGNATURES") }}
          </span>
          <signature-list-grid-view
            :object-id="transaction.id"
            :signatures="transaction.signatures"
          />
        </tab-pane>

        <tab-pane
          title="files"
          id="998"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_FILES) &&
            transaction.organization
          "
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component :object="transaction" />
          </div>
        </tab-pane>-->

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <transaction-view-logs :transaction="transaction" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { PAYMENT_STATUS_DRAFT } from "@/constants/payments";
import { Tabs, TabPane } from "@/components";
import TransactionViewGlobal from "../partials/TransactionViewGlobal.vue";
import TransactionViewLogs from "../partials/TransactionViewLogs.vue";
import SignatureListGridView from "../../SignatureManagement/partials/SignatureListGridView.vue";
import ListFileComponent from "@/components/File/ListFileComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    TransactionViewGlobal,
    TransactionViewLogs,
    ListFileComponent,
    SignatureListGridView,
  },

  mixins: [requestErrorMixin],

  props: {
    transactionId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      transaction: null,
      PAYMENT_STATUS_DRAFT: PAYMENT_STATUS_DRAFT,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {

    async get() {
      try {
        await this.$store.dispatch("transactionDpas/get", this.transactionId);
        this.transaction = this.$store.getters["transactionDpas/transaction"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    validateTransaction(transaction) {
      this.$emit("onValidateTransaction", transaction);
    },
    cancelTransaction(transaction) {
      this.$emit("onCancelTransaction", transaction);
    },
    editTransaction(transaction) {
      this.$emit("onEditTransaction", transaction);
    },
    deleteTransaction(transaction) {
      this.$emit("onDeleteTransaction", transaction);
    },
    toggleOnHold(transaction) {
      this.$emit("onToggleOnHold", transaction);
    },
    sendPaymentsToDpa(transaction) {
      this.$emit("onSendPaymentsToDpa", transaction);
    }
  },
};
</script>
